<template>
  <div style="height: 100%;width:100%;">
    <v-card  flat>
      <v-card-text>
        <v-row v-if="useCountries && countries && !country">
          <v-col cols="12" xs="12">
            <img :src="urlLogo"/>
            <v-autocomplete
                v-model="country"
                :loading="loading"
                :items="countries"
                hide-no-data
                hide-details
                return-object
                class="mx-4"
                flat
                @change="select = null"
                item-text="n"
                label="Land"
                solo
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title v-html="data.item.n"></v-list-item-title>
                  <v-list-item-subtitle v-html="data.item.s"></v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row v-if="country || !useCountries">
          <v-col cols="12" xs="12">
            <v-text-field v-model="search" clearable outlined></v-text-field>
            <!--
            <v-autocomplete
                v-if="!select"
                v-model="select"
                :loading="loading"
                :items="items"
                :search-input.sync="search"
                hide-no-data
                hide-details
                return-object
                class="mx-4"
                flat
                color="primary"
                append-outer-icon="search"
                @change="getDetails"
                item-text="name"
                label="Hotelname"
                solo
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title v-html="data.item.name"></v-list-item-title>
                  <v-list-item-subtitle v-html="data.item.gid + ' (' + data.item.country + ', ' + data.item.region + ')'"></v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
            -->
          </v-col>
          <v-col cols="12" xs="12" sm="6" align="right" v-if="false">
            <v-btn class="mx-2" v-if="select" @click="select = null; hotel = null;">
              <v-icon class="mr-2">hotel</v-icon>
              {{ truncatedString(select.name) }}
              <v-icon color="red">close</v-icon>
            </v-btn>
            <v-btn v-if="useCountries && country" @click="country = undefined;select = null; hotel = null;">
              <v-icon class="mr-2">map</v-icon>
              {{ country.n }}
              <v-icon color="red">close</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" xs="12" v-if="select && hotel && showType === 0">
            <v-carousel v-model="cmodel" hide-delimiters :style="stageStyle" dark>
              <v-carousel-item v-for="pic in hotel.imageList" :key="pic" class="pa-4" dark>
                <v-sheet color="white">
                  <div
                      :style="stageStyle + 'background-position: center;background-repeat: none;background-size: contain;background-image: url(\'' + pic.url +'\')'">
                  </div>
                </v-sheet>

              </v-carousel-item>
            </v-carousel>
          </v-col>
          <v-col cols="12" xs="12" v-if="select && hotel && showType === 1">
            <div v-if="false"
                :style="stageStyle + 'background-position: center;background-repeat: none;background-size: contain;background-image: url(\'' + hotel.map +'\')'">
            </div>
            <GoogleMapLoader
                :style="stageStyle + ';display:grid;'"
                :mapConfig="mapConfig"
                :apiKey="mapKey"
            />
          </v-col>
          <v-col cols="12" xs="12" v-if="select && hotel && showType === 4">
            <div
                 :style="stageStyle + 'background-position: center;background-repeat: none;background-size: contain;background-image: url(\'' + hotel.clima +'\')'">
            </div>
          </v-col>
          <v-col cols="12" xs="12" v-if="select && hotel && showType === 2 && hotel.detail">

            <div :style="stageStyle" v-if="hotel.detail.urls">
              <div v-if="hotel.imageList && hotel.imageList.length > 0">
                <img :src="hotel.imageList[0].url" v-if="hotel.imageList.length > 0" class="mr-1">
                <img :src="hotel.imageList[1].url" v-if="hotel.imageList.length > 1" class="mr-1">
                <!--
                <img :src="hotel.imageList[2].url" v-if="hotel.imageList.length > 2" class="mr-1">
                <img :src="hotel.imageList[3].url" v-if="hotel.imageList.length > 3">
                -->
              </div>
              <div v-for="(addr, i) in hotel.detail.addresses" :key="i">
                <span class="title">
                  Standort
                </span> <br>
                <span class="subtitle-1">
                  {{addr.street}} {{addr.streetNum}}<br>
                  {{addr.zip}} {{addr.cityName}}</span>
              </div>
              <div v-for="(url, i) in hotel.detail.urls" :key="i">
                <span class="title">
                  Web:
                </span> <br>
                <span class="subtitle-1"><a :href="url.url" target="_blank">{{ url.url }}</a></span>
              </div>
              <div v-for="(section, i) in hotel.detail.texts['de'].sections" :key="i">
                <span class="title pt-2">
                  {{ section.title }}
                </span> <br>
                <span class="description">
                  {{ section.para }}
                </span>
              </div>
            </div>
          </v-col>
          <v-col cols="12" xs="12" v-if="showType === 3" class="mx-0 py-0">
            <v-data-table
                :headers="headers"
                :items="items"
                fixed-header
                :items-per-page="-1"
                @click:row="doSelectRow"
                hide-default-footer
                :height="tableHeight"
            >
              <template v-slot:item.name="{ item }">
                <v-row>
                  <v-col cols="12" xs="6">
                    <!--<img v-if="item.thumb" :src="item.thumb" width="128" style="float: left;" class="mr-4"/>-->
                    <ImageItem
                        class="article-item__image mr-4"
                        v-if="item.thumb"
                        :source="item.thumb"
                        style="float: left;"
                    />
                    <div v-else style="width: 320px; height: 240px;float:left; background-color: lightgray;" class="mr-4"></div>
                    <span class="title">{{item.name}}</span><br>
                    <span class="subtitle-1">{{item.country}} / {{item.region}}</span>&nbsp;<span class="text">{{item.provider}}</span>
                  </v-col>
                </v-row>

              </template>
            </v-data-table>
          </v-col>
        </v-row>


      </v-card-text>
    </v-card>
    <v-toolbar bottom absolute width="100%">
      <v-toolbar-items class="pa-2">
        <v-btn class="mr-2" v-if="hotel && hotel.gid && hotel.detail && hotel.detail.texts && hotel.detail"
               @click="show(2)">Details
        </v-btn>
        <v-btn class="mx-2" v-if="hotel && hotel.imageList && hotel.imageList.length > 0" @click="show(0)">Bilder
        </v-btn>
        <v-btn class="mx-2" v-if="hotel && ((hotel.map && hotel.map.length > 0) || hotel.detail)" @click="show(1)">Karte</v-btn>

        <v-btn class="mx-2" v-if="hotel && hotel.gid && hotel.clima" @click="show(4)">Klima</v-btn>
        <v-btn class="mx-2" v-if="hotel && hotel.gid && hotel.detail" @click="openGiata">Drive</v-btn>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
import Vue from "vue";
import ImageItem from "./../../ImageItem.vue";
import GoogleMapLoader from "@/components/module/GoogleMapLoader.vue";

export default {
  name: 'OfficeClient',
  components: {GoogleMapLoader, ImageItem},
  data() {
    return {
      gmap: {
        mapConfig: Object,
        apiKey: String,
      },
      urlLogo: './../../assets/Logo.png',
      countries: undefined,
      country: {
        n: 'Italien',
        s: 'IT'
      },
      useCountries: false,
      loading: false,
      mapConfig: {
        center: { lat: -34.397, lng: 150.644 },
        zoom: 8,
      },
      mapKey: 'AIzaSyAetXJoHCE7Ealp9F5OECNvOF6hItEPabk',
      items: [],
      stageStyle: 'height:420px;overflow-y: auto;overflow-x: hidden;',
      stageHeight: 420,
      cmodel: 0,
      search: null,
      showType: 0,
      hotel: undefined,
      details: undefined,
      select: null,
      maxLength: 24,
      tableHeight: 100,
      Map: null,
      myMap: null,
      headers: [
        {text: 'Name', align: 'left', value: 'name'},
          /*
        {text: 'Anbieter', align: 'left', value: 'provider'},
        {text: 'Land', value: 'country'},
        {text: 'Region', value: 'region'}

           */
      ],
    }
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val)
    },
  },
  methods: {
    truncatedString(value) {
      return value.length > this.maxLength
          ? `${value.slice(0, this.maxLength)}...`
          : value;
    },
    getDetails() {
      this.querySelectionsDetails(this.select.gid)
    },
    doSelectRow(item) {
      this.select = item
      this.getDetails()
    },
    querySelectionsDetails(gid) {
      const cmp = this
      cmp.hotel = null
      Vue.prototype.$apiOfficeClient.getHotelDetail({
        gid: gid
      }, function (result) {
        if (result) {
          cmp.hotel = result.hotels[0]
          if (Object.keys(result.detail).length > 0) {
            cmp.hotel.detail = result.detail
            if (result.detail.geoCodes && result.detail.geoCodes.length > 0) {
              cmp.mapConfig.center.lat = result.detail.geoCodes[0].latitude
              cmp.mapConfig.center.lng = result.detail.geoCodes[0].longitude
            }

          }

          cmp.$nextTick(function () {
            cmp.cmodel = 0
            if (cmp.hotel.detail) {
              cmp.show(2)
            } else {
              cmp.cmodel = 1
              cmp.show(0)
              cmp.cmodel = 0
            }
          })
        }
        cmp.loading = false
      }, this.onFailedCode)
    },
    querySelections(v) {
      const cmp = this
      // if (v.length < 2) return
      cmp.loading = true
      Vue.prototype.$apiOfficeClient.queryHotelByName({
        name: v,
        country: null, //cmp.country.n,
      }, function (result) {
        cmp.loading = false
        cmp.items = result
        cmp.show(3)
      }, this.onFailedCode)
    },
    onFailedCode: function () {
      this.loading = false
    },
    openGiata: function () {
      const gid = this.hotel.gid
      window.open('https://myhotel.giatamedia.com/hotel-directory/' + gid + "?lang=de", '_new')
    },
    /**
     *
     * @param type 0 = Bilder, 1 = map
     */
    show: function (type) {
      this.showType = type
      if (type === 1) {
        this.showMap()
      }
    },
    initMap: async function () {
      //
    },
    showMap: function () {
      //
    },
    updateStageStyle: function () {
      this.stageHeight = window.innerHeight - 200
      this.stageStyle = 'height:' + this.stageHeight + 'px;overflow-y: auto;overflow-x: hidden;'
      this.tableHeight = this.stageHeight
    }
  },
  mounted() {
    const cmp = this
    cmp.initMap()

    this.updateStageStyle()
    if (cmp.useCountries) {
      Vue.prototype.$apiOfficeClient.getCountries({}, function (result) {
        cmp.countries = result
      }, this.onFailedCode)
    }
  }
}
</script>

<style scoped>

</style>
